import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingPhotoColorizerConfig } from '@/data/landingConfig/landingPhotoColorizerConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PhotoColorizer } from './schemaObject';

const PhotoColorizer = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_PhotoColorizer} />
			<LandingTemplate
				data={landingPhotoColorizerConfig}
				funnelLinkService={GenerateLandingLinkService.funnelPhotoColorizer()}
			/>
		</>
	);
};

export default PhotoColorizer;
